import { IAlanI } from "./IAlan";
import { IEk, IUyarVT, IUyarYollar, IVT, IYollar } from "./IKart.interface";

/** Doğruluk Durumları */
export type Dogruluk = 'Doğru' | 'Yanlış' | 'Bilinmiyor';

/** Parametre Türleri */
export type ITurParametre =
    | 'Yazı' | 'Yazı Alanı' | 'Parola' | 'Sayı' | 'Doğruluk' | 'Onay' | 'Anahtar'
    | 'Tarih' | 'Tarih Saat' | 'Ay' | 'Hafta' | 'Saat'
    | 'Resim' | 'Video' | 'Dosya' | 'Ses' | 'XYZ'
    | 'Grup' | 'Para' | 'Liste' | 'Tablo'
    | 'KareKod' | 'BarKod' | '2liSatır' | '3lüSatır' | 'Sekme' | 'Açılır Kutu' | 'Simgeli Başlık';

/** Parametre Değer Tipi */
export type IParametreDegerTuru =
    | IParametre
    | IParametre[]
    | IKokParametre<IParametre, ITurParametre>[]
    | IKokParametre<IParametre[], ITurParametre>[]
    | IKokParametre<IParametre, ITurParametre>
    | IKokParametre<IParametre[], ITurParametre>
    | string
    | number
    | Date
    | { x: number, y: number, z: number }
    | any;

export interface IParametreKontrol {
    fn?: string | ((form: any, itm: any) => boolean);
    renk?: string;
    mesaj?: string;
}


export interface IParametreAyarlar {
    [key: string]: any;
    sadeceOkunur?: boolean;
    gorunur?: boolean;
    zorunlu?: boolean;
    solSimge?: "search" | "users" | string;
    arama?: boolean;
    min?: number | Date;
    maks?: number | Date;
    adim?: number;
    format?: string;
    satirSayisi?: number
}

/** Parametrelerin temel arayüzü */
export interface IKokParametre<Tdeger extends IParametreDegerTuru, Tturu extends ITurParametre> {
    turu: Tturu;
    baslik?: string;
    ismi: string;
    yerTutucu?: string;
    aciklama?: string;
    altAciklama?: string;
    ipucu?: string;
    degeri?: Tdeger;

    ayarlar?: IParametreAyarlar;
    kontroller?: IParametreKontrol[];
    hatalar?: { mesaj?: string; renk?: string }[];
    uyarilar?: { mesaj?: string; renk?: string }[];

    yetkiler?: {
        gorebilir?: string[];
        degistirebilir?: string[];
        silebilir?: string[];
    }

    alan?: IAlanI;

    mesgul?: boolean;
}

/** Her parametre bu arayüzü uygular */
export interface IParametre extends IKokParametre<any, ITurParametre> { }

/** Örnek parametre türleri */
interface IAyarlarOrtak {
    zorunlu?: boolean;
    solSimge?: string;
    format?: string;
    min?: number | Date;
    maks?: number | Date;
    adim?: number;
}

// Parametre ayarları detaylandırılmış versiyonlar
interface IYaziAyarlar extends IAyarlarOrtak { satirSayisi?: number; }
interface IParolaAyarlar extends IAyarlarOrtak { }
interface ISayiAyarlar extends IAyarlarOrtak { }
interface IDogrulukAyarlar extends IAyarlarOrtak { }
interface IOnayAyarlar extends IAyarlarOrtak { }
interface IAnahtarAyarlar extends IAyarlarOrtak { }
interface ITarihAyarlar extends IAyarlarOrtak { }
interface ITarihSaatAyarlar extends IAyarlarOrtak { }
interface IAyAyarlar extends IAyarlarOrtak { }
interface IHaftaAyarlar extends IAyarlarOrtak { }
interface ISaatAyarlar extends IAyarlarOrtak { }
interface IResimAyarlar extends IAyarlarOrtak { kabulTipleri?: string[]; maksBoyutMb?: number; }
interface IVideoAyarlar extends IAyarlarOrtak { kabulTipleri?: string[]; maksBoyutMb?: number; }
interface ISesAyarlar extends IAyarlarOrtak { kabulTipleri?: string[]; maksBoyutMb?: number; }
interface IDosyaAyarlar extends IAyarlarOrtak { kabulTipleri?: string[]; maksBoyutMb?: number; }
interface IXYZAyarlar extends IAyarlarOrtak { }
interface IParaAyarlar extends IAyarlarOrtak { paraBirimi?: string; }
interface IListeAyarlar extends IAyarlarOrtak { secenekler?: (string | { etiket: string, deger: any })[]; coklu?: boolean; }
interface ITabloAyarlar extends IAyarlarOrtak { kolonlar?: string[]; }
interface IKareKodAyarlar extends IAyarlarOrtak { }
interface IBarKodAyarlar extends IAyarlarOrtak { }
interface IGrupAyarlar extends IAyarlarOrtak { }
interface ISekmeAyarlar extends IAyarlarOrtak { }
interface IIkiliSatirAyarlar extends IAyarlarOrtak { }
interface IUcluSatirAyarlar extends IAyarlarOrtak { }
interface IAcılırKutuAyarlar extends IAyarlarOrtak, IParametreAyarlar {
    liste?: any[];
    arama?: boolean;
    coklu?: boolean;
    silme?: boolean;
    secenekler?: (string | { etiket: string, deger: any })[];
    secenekItm?: string;
    fapiAyarlar?: {
        vt?: IUyarVT;
        yol?: IUyarYollar;
        sorgu?: string | { [key: string]: string };
        pipeFunc?: string;
    },
    olaylar?: {
        degisti?: string;
        secildi?: string;
        secimSilindi?: string;
    }
}

interface ISimgeAyarlar extends IAyarlarOrtak, IParametreAyarlar {
    boyut?: number;
    renk?: string;
    sekil?: 'Kare' | 'Yuvarlak' | 'Yuvarlak Köşe';
}


// Parametre tipleri
export type IYaziParametre = IKokParametre<string, "Yazı"> & { ayarlar?: IYaziAyarlar };
export type IParolaParametre = IKokParametre<string, "Parola"> & { ayarlar?: IParolaAyarlar };
export type ISayiParametre = IKokParametre<number, "Sayı"> & { ayarlar?: ISayiAyarlar };
export type IDogrulukParametre = IKokParametre<Dogruluk, "Doğruluk"> & { ayarlar?: IDogrulukAyarlar };
export type IOnayParametre = IKokParametre<boolean, "Onay"> & { ayarlar?: IOnayAyarlar };
export type IAnahtarParametre = IKokParametre<string, "Anahtar"> & { ayarlar?: IAnahtarAyarlar };
export type ITarihParametre = IKokParametre<Date, "Tarih"> & { ayarlar?: ITarihAyarlar };
export type ITarihSaatParametre = IKokParametre<Date, "Tarih Saat"> & { ayarlar?: ITarihSaatAyarlar };
export type IAyParametre = IKokParametre<string, "Ay"> & { ayarlar?: IAyAyarlar };
export type IHaftaParametre = IKokParametre<string, "Hafta"> & { ayarlar?: IHaftaAyarlar };
export type ISaatParametre = IKokParametre<string, "Saat"> & { ayarlar?: ISaatAyarlar };
export type IResimParametre = IKokParametre<IEk, "Resim"> & { ayarlar?: IResimAyarlar };
export type IVideoParametre = IKokParametre<IEk, "Video"> & { ayarlar?: IVideoAyarlar };
export type ISesParametre = IKokParametre<IEk, "Ses"> & { ayarlar?: ISesAyarlar };
export type IDosyaParametre = IKokParametre<IEk, "Dosya"> & { ayarlar?: IDosyaAyarlar };
export type IXYZParametre = IKokParametre<{ x: number, y: number, z: number }, "XYZ"> & { ayarlar?: IXYZAyarlar };
export type IGrupParametre = IKokParametre<IParametre[], "Grup"> & { ayarlar?: IGrupAyarlar };
export type ISekmeParametre = IKokParametre<IParametre[], "Sekme"> & { ayarlar?: ISekmeAyarlar };
export type IParaParametre = IKokParametre<number, "Para"> & { ayarlar?: IParaAyarlar };
export type IListeParametre = IKokParametre<any[], "Liste"> & { ayarlar?: IListeAyarlar };
export type ITabloParametre = IKokParametre<Record<string, any>[], "Tablo"> & { ayarlar?: ITabloAyarlar };
export type IKareKodParametre = IKokParametre<string, "KareKod"> & { ayarlar?: IKareKodAyarlar };
export type IBarKodParametre = IKokParametre<string, "BarKod"> & { ayarlar?: IBarKodAyarlar };
export type IIkiliSatirParametre = IKokParametre<IParametre[], "2liSatır"> & { ayarlar?: IIkiliSatirAyarlar };
export type IUcluSatirParametre = IKokParametre<IParametre[], "3lüSatır"> & { ayarlar?: IUcluSatirAyarlar };
export type IAcılırKutuParametre = IKokParametre<IParametre[], "Açılır Kutu"> & { ayarlar?: IAcılırKutuAyarlar };
export type ISimgeliBaslikParametre = IKokParametre<{
    simge?: string;
    baslik?: string;
    altBaslik?: string;
}, "Simgeli Başlık"> & { ayarlar?: ISimgeAyarlar };

// Tüm parametreleri içeren birleşik tip
export type IParametreTumu =
    | IYaziParametre
    | IParolaParametre
    | ISayiParametre
    | IDogrulukParametre
    | IOnayParametre
    | IAnahtarParametre
    | ITarihParametre
    | ITarihSaatParametre
    | IAyParametre
    | IHaftaParametre
    | ISaatParametre
    | IResimParametre
    | IVideoParametre
    | ISesParametre
    | IDosyaParametre
    | IXYZParametre
    | IGrupParametre
    | ISekmeParametre
    | IParaParametre
    | IListeParametre
    | ITabloParametre
    | IKareKodParametre
    | IBarKodParametre
    | IIkiliSatirParametre
    | IUcluSatirParametre
    | IAcılırKutuParametre
    ;



/** AYRAÇ:  */
/** AYRAÇ: Kontrolleri kontrol eder */
export async function kontrolDeger(itm: any, parametreler: IParametreTumu[]): Promise<boolean> {
    // Kontroller yoksa geçerli say
    if (!('kontroller' in itm)) {
        return true;
    }

    // Hataları sıfırla
    itm.hatalar = [];
    itm.uyarilar = [];

    // Tüm kontrolleri çalıştır
    for (const key of Object.keys(itm.kontroller)) {
        const knt = itm.kontroller[key];
        // console.log(knt);
        // Kontrol fonksiyonu async veya sync olabilir
        const tsCode = `
          (function (form: any, itm: any)  {
              ${knt.fn}
          })
        `;
        const jsCode = tsCode.replace(/:\s*(?:any|string|number|boolean|void|never|object|unknown)(?:\[\])?\s*/g, ' ');

        eval(jsCode)(parametreler, itm);        // çalıştır
        // console.log(result);

        // const sonuc = await Promise.resolve(knt.fn(this.parametreler, itm));
    }

    // Değişiklikleri Angular'a bildir
    // this.CD.detectChanges();

    // Kontroller sonucu
    return itm.hatalar.length === 0;
}


/** Tüm parametreleri paralel kontrol eder ve hataları döner */
export async function tumHatalariniAl(parametreler: IParametreTumu[]): Promise<{ hatalar: any[]; uyarilar: any[] }> {
    const sonuc = { hatalar: [] as any[], uyarilar: [] as any[] };

    const gez = async (itm: any) => {
        await kontrolDeger(itm, parametreler);

        if (itm.hatalar && itm.hatalar.length > 0) {
            sonuc.hatalar.push({
                parametre: itm,
                hatalar: itm.hatalar
            });
        }

        if (itm.uyarilar && itm.uyarilar.length > 0) {
            sonuc.uyarilar.push({
                parametre: itm,
                uyarilar: itm.uyarilar
            });
        }

        // Alt parametreler
        if (itm.turu === 'Grup' || itm.turu === 'Sekme') {
            const altDegerler = itm.degeri || [];
            for (const alt of altDegerler) {
                await gez(alt);
            }
        } else if (itm.turu === '2liSatır') {
            await gez(itm.degeri.solTaraf);
            await gez(itm.degeri.sagTaraf);
        } else if (itm.turu === '3luSatır') {
            await gez(itm.degeri.solTaraf);
            await gez(itm.degeri.ortaTaraf);
            await gez(itm.degeri.sagTaraf);
        }
    };

    for (const param of parametreler) {
        await gez(param);
    }

    return sonuc;
}

/** Parametreleri json ve dosyalar olmak üzere ayırır */

export function parametreAyikla(veri: Array<any>): { json: any; dosyalar: { _id: string; dosya: any; objectUrl ?: string } [] } {
    const rslt: any = {};
    const dosyalar: { _id: string; dosya: any; objectUrl?: string }[] = [];

    const gez = (element: any): any => {
        if (element.turu === "Grup") {
            return this._toFormData(element.degeri).json;
        } else if (element.turu === "Sekme") {
            const sekmeObj: any = {};
            if (element.ayarlar?.jsonGrup) {
                element.degeri.forEach((sekmeElement: any) => {
                    sekmeObj[sekmeElement.ismi] = this._toFormData(sekmeElement.degeri).json;
                });
            } else {
                element.degeri.forEach((sekmeElement: any) => {
                    Object.assign(sekmeObj, this._toFormData(sekmeElement.degeri).json);
                });
            }
            return sekmeObj;
        } else if (element.turu === "2liSatır") {
            return {
                [element.degeri.solTaraf.ismi]: element.degeri.solTaraf.degeri,
                [element.degeri.sagTaraf.ismi]: element.degeri.sagTaraf.degeri
            };
        } else if (element.turu === "3luSatır") {
            return {
                [element.degeri.solTaraf.ismi]: element.degeri.solTaraf.degeri,
                [element.degeri.ortaTaraf.ismi]: element.degeri.ortaTaraf.degeri,
                [element.degeri.sagTaraf.ismi]: element.degeri.sagTaraf.degeri
            };
        } else {
            // 📌 Dosya kriteri: degeri içinde id + dosya + objectUrl olması
            if (element.degeri && element.degeri.dosya && element.degeri._id && element.degeri.objectUrl) {
                // const id = new FikoYTId().toString();
                // element.degeri.id = id; // id atanıyor

                dosyalar.push({
                    _id: element.degeri._id.toString(),
                    dosya: element.degeri.dosya,
                    objectUrl: element.degeri.objectUrl
                });

                return element.degeri._id.toString(); // JSON'a sadece id yazılacak
            }

            return element.degeri;
        }
    };

    Array.from(veri).forEach(element => {
        rslt[element.ismi] = gez(element);
    });

    return { json: rslt, dosyalar };
}